import React from "react";
import OptImg from "@/components/OptImg";

const NewsCard = ({ img, title, subtitle }) => {
  return (
    <div className="flex flex-col bg-[#f8fafb] hover:shadow-lg transition rounded-xl p-0">
      <div className="w-full aspect-[4/3] overflow-hidden rounded-t-xl">
        <OptImg
          src={img}
          alt={title}
          className="w-full h-full object-cover object-center transition hover:scale-105 duration-300"
        />
      </div>
      <div className="flex flex-col p-4">
        <div className="text-lg font-bold text-[#101616] mb-1">{title}</div>
        {subtitle && (
          <div className="text-base font-semibold text-[#101616] mb-1 opacity-80">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsCard;
